import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BalanceQuery, config, PopulationQuery, ScreenType } from '@fgb/core';
import { Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
  @Input() backButtonLink?: string;
  @Input() pageTitle: string;
  @Input() showBalance: boolean = true;
  @Input() showQr: boolean = true;
  @Input() showFooter: boolean = true;
  isFreePopulation: boolean = false;

  screenType = ScreenType;
  pointsBalance$: Observable<number | undefined>;

  constructor(
    private balanceQuery: BalanceQuery,
    private router: Router,
    private location: Location,
    private populationQuery: PopulationQuery
  ) {}

  ngOnInit() {
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.isFreePopulation = this.populationQuery.userInPopulation([Populations.Free]);
  }

  gotoWallet() {
    this.router.navigate(['/rewards/wallet']);
  }

  goBack() {
    if (this.backButtonLink) {
      this.router.navigate([this.backButtonLink]);
    } else {
      this.location.back();
    }
  }
}
